import React, { useEffect, useState } from "react";
import { ButtonAddHLPure, SearchBarHLPure, FilterHLPure, GridSelectionHLPure, DialogYesNoHLPure } from "../../pures";
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import './procedure-administration-principal.css'
const ProcedureAdministrationPrincipalView = (props) => {
    let {
        t,
        setProcedureSelectedGrid,
        procedures,
        setShowDetails,
        setViewSelected,
        proceduresTypes,
        procedureSelectedGrid
    } = props

    let is1100 = useMediaQuery('(max-width: 1100px)')
    let is560 = useMediaQuery('(max-width: 560px)')
    let is820 = useMediaQuery('(max-width: 820px)')


    const [proceduresGrid, setProceduresGrid] = useState([])
    const [search, setSearch] = useState('')
    const [filter, setFilter] = useState(0)
    const [showModalDelete, setShowModalDelete] = useState(false)

    const headerColumnOne = (props) => {
        return <span className="procedureAdministrationPrincipalView-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="procedureAdministrationPrincipalView-header-cell-two">{props.title}</span>;
    };

    const headerColumnThree = (props) => {
        return <span className="procedureAdministrationPrincipalView-header-cell-three">{props.title}</span>;
    };

    const headerColumnFour = (props) => {
        return <span className="procedureAdministrationPrincipalView-header-cell-four">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='procedureAdministrationPrincipalView-cell-one'>
                <div className="procedureAdministrationPrincipalView-column1-container">
                    <p className='procedureAdministrationPrincipalView-column1-title'>
                        {props.dataItem.name}
                    </p>
                    <p className='procedureAdministrationPrincipalView-subtitle-column1'>
                        {props.dataItem.completeDate}
                    </p>
                </div>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='procedureAdministrationPrincipalView-cell-two'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.entity}
                </span>
            </td>
        );
    };

    const cellColumnThree = (props) => {
        return (
            <td className='procedureAdministrationPrincipalView-cell-three'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.dateConvertFinish}
                </span>
            </td>
        );
    };

    const cellColumnFour = (props) => {
        return (
            <td className='procedureAdministrationPrincipalView-cell-Four'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.status}
                </span>
            </td>
        );
    };

    useEffect(() => {
        if (!procedures || procedures.length === 0) return
        setProceduresGrid(procedures)
    }, [procedures])

    useEffect(() => {
        let copyProcedures = [...procedures]
        let newProcedures = []
        if (filter === 0) {
            newProcedures = copyProcedures.filter(procedure => procedure.name.toLowerCase().indexOf(search.toLowerCase()) >= 0)
        } else {
            newProcedures = copyProcedures.filter(procedure => procedure.name.toLowerCase().indexOf(search.toLowerCase()) >= 0)
        }

        setProceduresGrid(newProcedures)

    }, [search, filter])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const onChangeFilter = (e) => {
        let value = e.target.value
        value = (value) ? Number(value) : 0
        setFilter(value)
    }

    const handleNewProcedure = () => {
        setViewSelected(t("procedureAdministrationView.new.prodecure"))
    }

    const handleOpenModalDelete = (dataItem) => {
        setProcedureSelectedGrid(dataItem)
        setShowModalDelete(true)
    }

    const handleCloseModalDelete = () => {
        setShowModalDelete(false)
    }

    const handleDelete = () => {
        setShowModalDelete(false)
    }

    return (
        <Container>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="procedureAdministrationPrincipalView-container"
            >
                <div className="procedureAdministrationPrincipalView-header">
                    <div className="procedureAdministrationPrincipalView-btn-add">
                        <ButtonAddHLPure
                            iconAdd={true}
                            nameBtn={t("procedureAdministrationView.new.prodecure")}
                            onClickBtn={() => handleNewProcedure()}
                        />
                    </div>
                    <div className="procedureAdministrationPrincipalView-btn-seacrh">
                        <SearchBarHLPure
                            placeholder={t("procedureAdministrationView.search.prodecure")}
                            onSearchChange={((e) => onChangeSearch(e))}
                        />
                    </div>
                    <FilterHLPure
                        options={proceduresTypes}
                        nameOption="name"
                        valueItem="id"
                        onFilterChange={() => onChangeFilter('')}
                    />
                </div>
                <div className="procedureAdministrationPrincipalView-grid-container">
                    {/* Grid con paginación */}
                    <GridSelectionHLPure
                        dataGrid={proceduresGrid}
                        skip={0}
                        take={5}
                        styleGeneral={true}
                        styleGeneralClass={"procedureAdministrationPrincipalView-general-grid"}
                        onSelectedItem={setProcedureSelectedGrid}
                        setShowDetails={setShowDetails}
                        setNameComponentUser={setViewSelected}
                        columnTwo={(is560) ? false : true}
                        columnThree={(is1100) ? false : true}
                        columnFour={(is820) ? false : true}
                        columnFive={true}
                        titleRow1={t("procedureAdministrationPrincipalView.title.grid.1")}
                        titleRow2={t("procedureAdministrationPrincipalView.title.grid.2")}
                        titleRow3={t("procedureAdministrationPrincipalView.title.grid.3")}
                        titleRow4={t("procedureAdministrationPrincipalView.title.grid.4")}
                        titleRow5={t("procedureAdministrationPrincipalView.title.grid.5")}
                        headerColumnOne={headerColumnOne}
                        cellColumnOne={cellColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnTwo={cellColumnTwo}
                        headerColumnThree={headerColumnThree}
                        cellColumnThree={cellColumnThree}
                        headerColumnFour={headerColumnFour}
                        cellColumnFour={cellColumnFour}
                        iconOneActive={true}
                        labelOneActions={t("procedureAdministrationView.details")}
                        iconTrashActive={true}
                        activeDialogTrash={true}
                        btnOpenDialogTrash={(dataItem) => handleOpenModalDelete(dataItem)}
                        labelFourthActions={t("procedureAdministrationView.details")}
                        styleGrid={{ maxHeight: '400px' }}
                    />
                </div>
                {
                    showModalDelete && (
                        <DialogYesNoHLPure
                            cancel={() => handleCloseModalDelete()}
                            textBtnCancel={t("button.cancel")}
                            saveBtn={t("button.delete")}
                            titleDialog={t("procedureAdministrationPrincipalView.title.modal.delete")}
                            handleSubmit={() => handleDelete()}
                        >
                            <div className='procedureAdministrationPrincipalView-dialog-delete'>
                                <h1>{`${t("procedureAdministrationPrincipalView.question.modal.delete")} ${procedureSelectedGrid.name}?`}</h1>
                            </div>
                        </DialogYesNoHLPure>
                    )
                }
            </Grid>
        </Container>
    )
}

export { ProcedureAdministrationPrincipalView as default }